<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div class="col-12 col-md-7 col-lg-6 auth-main-col text-center p-5">
    <div class="d-flex flex-column align-content-end">
      <div class="alert alert-danger" v-show="isError" v-html="errorMessage"></div>
      <div v-show="!isLoading">
        <div class="app-auth-body mx-auto" v-if="!validKey">
          <div class="app-auth-branding mb-4 mt-4">
            <img class="logo-icon me-2 img-fluid" src="@/assets/images/logo-aff.png" alt="logo">
          </div>
          <h2 class="auth-heading text-center mb-3">Restore access</h2>
          <div v-if="!sended" class="auth-form-container text-start">
            <form class="auth-form login-form" @submit.prevent="sendCode">
              <div class="email mb-3">
                <label class="sr-only" for="reset-email">Email</label>
                <input id="reset-email" name="email" v-model="user_username" type="text" class="form-control signup-email" placeholder="Email address" required="required">
              </div><!--//form-group-->
              <div class="text-center">
                <button type="submit" class="btn btn-primary w-100 theme-btn mx-auto">Send recovery code</button>
              </div>
            </form>

            <div class="auth-option text-center pt-1">Or <router-link class="text-link" to="/member/login" >login</router-link> with old password.</div>
          </div><!--//auth-form-container-->
          <div v-else>
            <div class="alert alert-success">Recovery instruction sended.<br>Check your email box.</div>
            <div class="alert alert-warning">The password change request<br>is valid for 20 minutes.</div>
            <div class="auth-option text-center pt-1">Or <router-link class="text-link" to="/member/login" >login</router-link> with old password.</div>
          </div>


        </div><!--//auth-body-->
        <div class="app-auth-body mx-auto" v-else>
          <div class="app-auth-branding mb-4 mt-4">
            <img class="logo-icon me-2 img-fluid" src="@/assets/images/logo-aff.png" alt="logo">
          </div>
          <h2 class="auth-heading text-center mb-3">Restore access</h2>
          <div v-if="!reseted" class="auth-form-container text-start">
            <form class="auth-form login-form" @submit.prevent="setPass">
              <div class="password mb-3">
                <label class="sr-only" for="signup-password">New Password</label>
                <input id="signup-password" name="password" v-model="password" type="password" class="form-control signup-password" placeholder="New Password" required="required">
              </div><!--//form-group-->
              <div class="password mb-3">
                <label class="sr-only" for="signup-repassword">Re-type New Password</label>
                <input id="signup-repassword" name="repassword" v-model="repassword" type="password" class="form-control signup-password" placeholder="Re-type New Password" required="required">
              </div><!--//form-group-->
              <div class="text-center">
                <button type="submit" class="btn btn-primary w-100 theme-btn mx-auto">Set new password</button>
              </div>
            </form>
          </div><!--//auth-form-container-->
          <div v-else>
            <div class="alert alert-success">
              Password reset succcessful!
            </div>
            <div class="auth-option text-center pt-1">Try <router-link class="text-link" to="/member/login" >login</router-link> with new password.</div>
          </div>

        </div><!--//auth-body-->
      </div>
      <span v-if="isLoading" class="cssload-loader"><span class="cssload-loader-inner"></span></span>

    </div><!--//flex-column-->
  </div><!--//auth-main-col-->
  <div class="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
    <div class="auth-background-login">
    </div>

  </div><!--//auth-background-col-->
</template>

<script>
import {doLoading, errorMessage, isError, isLoading, loadingDone, clearError, logout, showError} from "@/inc/storage";
import {getCsrf, Request} from "@/inc/client";

export default {
  name: "ResetPage",
  data() {
    return {
      user_username: '',
      password: '',
      repassword: '',
      validKey : false,
      sended : false,
      reseted : false,
    }
  },
  setup() {
    return {
      isLoading, isError, errorMessage
    }
  },
  mounted() {
    logout()
    doLoading()
    this.checkKey()

  },
  methods: {
    checkKey : async function ()
    {
      clearError()
      if (!this.hasKey) {
        loadingDone()
        return
      }
      let This = this
      let payload = {
        ResetPass: {
          key: This.Key
        },
        _csrf: await getCsrf(),
        s: 'verify',
      }
      Request('reset', {url: "url", data: payload, method: 'POST'})
          .then(function (response)
          {
            if (response.data.key === This.Key) {
              This.validKey = true;
            }
            loadingDone()
          })
          .catch(() =>
          {
            loadingDone()
          })
    },

    sendCode : async function ()
    {
      clearError()
      let This = this
      let payload = {
        ResetPass: {
          email: this.user_username
        },
        _csrf: await getCsrf(),
        s: 'send',
      }
      doLoading()
      Request('reset', {url: "url", data: payload, method: 'POST'})
          .then(function (response)
          {
            console.log(response.data)
            if (response.data.ok === 1) {
              This.sended = true;
            }
            loadingDone()
          })
    },

    setPass: async function ()
    {
      clearError()
      if (!this.password || this.password !== this.repassword) {
        showError('Empty password or not equals to re-type password');
        return;
      }

      let This = this
      let payload = {
        ResetPass: {
          key: This.Key,
          password: this.password
        },
        _csrf: await getCsrf(),
        s: 'reset',
      }
      doLoading()
      Request('reset', {url: "url", data: payload, method: 'POST'})
          .then(function (response)
          {
            console.log(response.data)
            if (response.data.ok === 1) {
              This.reseted = true;
            }
            loadingDone()
          })
    },
  },
  computed : {
    hasKey : function (){
      return !!this.$route.query.key
    },
    Key : function (){
      return this.$route.query.key
    }
  }
}
</script>

<style scoped>

</style>